import { render, staticRenderFns } from "./CourseVideoBranchPicker.vue?vue&type=template&id=6f866574&"
import script from "./CourseVideoBranchPicker.vue?vue&type=script&lang=js&"
export * from "./CourseVideoBranchPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports